"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callsOutcomes = void 0;
var callsOutcomes;
(function (callsOutcomes) {
    callsOutcomes["CONSENTED"] = "consented";
    callsOutcomes["SUPPORT_COMPLETED"] = "supportCompleted";
    callsOutcomes["REMINDER_COMPLETED"] = "reminderCompleted";
    callsOutcomes["CALL_LATER"] = "callLater";
    callsOutcomes["INDETERMINATE"] = "indeterminate";
    callsOutcomes["VOICEMAIL_LEFT"] = "voicemailLeft";
    callsOutcomes["NO_VOICEMAIL_LEFT"] = "noVoicemailLeft";
    callsOutcomes["UNREACHABLE_ANSWERED"] = "unreachableAnswered";
    callsOutcomes["UNREACHABLE_UNANSWERED"] = "unreachableUnanswered";
    callsOutcomes["INELIGIBLE"] = "ineligible";
    callsOutcomes["DECLINED"] = "declined";
    callsOutcomes["DO_NOT_CALL"] = "doNotCall";
    callsOutcomes["PCP_CONFIRMATION_COMPLETED"] = "pcpConfirmationCompleted";
    callsOutcomes["TEST_FAILED_COMPLETED"] = "testFailedCompleted";
    callsOutcomes["POST_TEST_COMPLETED"] = "postTestCompleted";
    callsOutcomes["INCOMPLETE_CALL"] = "incompleteCall";
})(callsOutcomes || (exports.callsOutcomes = callsOutcomes = {}));
